import React from 'react';
import ErpDocPage from '../components/ErpDocPage';
import ErpTablePage from '../components/ErpTablePage';

const CreditNotes = () => {
  return <ErpDocPage moduleKey="credit_notes" />;
};

export default CreditNotes;